import Dilemma from './Dilemma';
export default Dilemma;
